import { defineComponent as _defineComponent } from 'vue';
import { BButton } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, onMounted, ref } from "vue";
import { useToast } from "@/composables/toast";
import { useUid } from "@/composables/utils/uid";
import { useUserTagsStore } from "@/stores/userTagsStore";
import { VALID_TAG_RE } from "../Tags/model";
import HeadlessMultiselect from "./HeadlessMultiselect.vue";
import Tag from "./Tag.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'StatelessTags',
    props: {
        value: { default: () => [] },
        disabled: { type: Boolean, default: false },
        clickable: { type: Boolean, default: false },
        useToggleLink: { type: Boolean, default: true },
        maxVisibleTags: { default: 5 },
        placeholder: { default: "Add Tags" }
    },
    emits: ["input", "tag-click"],
    setup(__props, { emit }) {
        const props = __props;
        const userTagsStore = useUserTagsStore();
        const { userTags } = storeToRefs(userTagsStore);
        const { warning } = useToast();
        onMounted(() => {
            userTagsStore.onMultipleNewTagsSeen(props.value);
        });
        function onAddTag(tag) {
            const newTag = tag.trim();
            if (isValid(newTag)) {
                userTagsStore.onNewTagSeen(newTag);
                emit("input", [...props.value, newTag]);
            }
            else {
                warning(`"${newTag}" is not a valid tag.`, "Invalid Tag");
            }
        }
        function onInput(val) {
            emit("input", val);
        }
        function onDelete(tag) {
            const val = [...tags.value];
            const index = tags.value.indexOf(tag);
            val.splice(index, 1);
            emit("input", val);
        }
        const tags = computed(() => props.value.map((tag) => tag.replace(/^name:/, "#")));
        const toggledOpen = ref(false);
        const toggleButtonId = useUid("toggle-link-");
        const trimmedTags = computed(() => {
            if (!props.useToggleLink || toggledOpen.value) {
                return tags.value;
            }
            else {
                return tags.value.slice(0, props.maxVisibleTags);
            }
        });
        const slicedTags = computed(() => {
            if (!props.useToggleLink) {
                return [];
            }
            else {
                return tags.value.slice(props.maxVisibleTags);
            }
        });
        function isValid(tag) {
            return tag.match(VALID_TAG_RE);
        }
        function onTagClicked(tag) {
            emit("tag-click", tag);
        }
        return { __sfc: true, props, emit, userTagsStore, userTags, warning, onAddTag, onInput, onDelete, tags, toggledOpen, toggleButtonId, trimmedTags, slicedTags, isValid, onTagClicked, BButton, HeadlessMultiselect, Tag };
    }
});
